// Bildschirm "Anmelden" (ST-SEC-001, ST-UX-001).
//
// Genau EINE Handlung (NFR-UX-004). Kein Passwortfeld, kein "Konto anlegen",
// kein "Passwort vergessen" -- nichts davon existiert, und jedes davon
// anzubieten waere ein Versprechen, das die Anwendung nicht haelt.

import type { ReactElement } from 'react';
import { Body1, Button, Card } from '@fluentui/react-components';

import { useScreenStyles } from '../shell/screen-styles.ts';

export function SignInScreen({ onSignIn }: { readonly onSignIn: () => void }): ReactElement {
  const styles = useScreenStyles();
  return (
    <Card className={styles.card}>
      <Body1>
        LIAISON verwendet dein Unternehmenskonto. Es gibt kein eigenes Passwort und keine zweite Anmeldung.
      </Body1>
      <div className={styles.actions}>
        <Button appearance="primary" onClick={onSignIn}>
          Mit Unternehmenskonto anmelden
        </Button>
      </div>
    </Card>
  );
}
